import "./four.css";
import Z from "../img/agency.mp4";
import React from "react";
import { Helmet } from 'react-helmet-async';

const Four = () => {
  return (
    <section className="f">
      <Helmet>
        <title>Our Agency - Bichitras Engineering Team | Global Software Development Studio</title>
        <meta name="description" content="We're engineers working across software, animation, brand and marketing. Based in Nepal, connected globally, driven by innovation and honest delivery." />
        <meta name="keywords" content="engineering team, software development agency, global software studio, Nepal developers, animation services, brand development, marketing solutions" />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What services does Bichitras engineering studio offer?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We offer software development, 3D modeling and architectural visualization, animation services, brand development, marketing solutions, and talent outsourcing for global businesses."
                }
              },
              {
                "@type": "Question",
                "name": "Where is Bichitras based?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We're based in Nepal but connected globally. We work with businesses worldwide and provide remote outsourcing services."
                }
              },
              {
                "@type": "Question",
                "name": "Why choose Bichitras over other agencies?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We're not an agency - we're engineers who build, design, and move ideas forward. We think like a product team, collaborate fast, adapt quickly, and deliver honestly with engineering logic applied to creative work."
                }
              },
              {
                "@type": "Question",
                "name": "How does Bichitras handle outsourcing projects?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We hire and manage talent for businesses who want to outsource development work. We don't work in silos - we integrate with your team and think strategically about solutions that work."
                }
              },
              {
                "@type": "Question",
                "name": "Does Bichitras provide IT outsourcing services?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, Bichitras specializes in comprehensive IT outsourcing services including software development, system architecture, database management, and complete technology solutions for businesses looking to outsource their IT needs globally."
                }
              },
              {
                "@type": "Question",
                "name": "What remote development outsourcing services does Bichitras offer?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras provides full-stack remote development outsourcing services including web applications, mobile apps, API development, cloud solutions, and custom software development with dedicated remote teams managed from Nepal."
                }
              },
              {
                "@type": "Question",
                "name": "How do offshore development services work with Bichitras?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our offshore development services provide cost-effective, high-quality development solutions from Nepal. We offer dedicated development teams, project-based outsourcing, and long-term offshore partnerships with seamless communication across time zones."
                }
              },
              {
                "@type": "Question",
                "name": "What business process outsourcing capabilities does Bichitras have?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras offers comprehensive business process outsourcing including software development processes, 3D modeling workflows, animation production pipelines, digital marketing processes, and complete project management for businesses seeking to outsource technical and creative operations."
                }
              },
              {
                "@type": "Question",
                "name": "What is Bichitras and what services do they provide?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras is a global IT service provider and engineering studio based in Nepal, serving businesses worldwide. We specialize in complete outsourcing solutions including software development, 3D modeling, animation, talent management, and any computer-based work that businesses need to outsource. We're not an agency - we're engineers who build, design, and move ideas forward."
                }
              },
              {
                "@type": "Question",
                "name": "Why should businesses choose Bichitras for outsourcing needs?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras is a global IT service provider that offers cost-effective, high-quality outsourcing solutions with engineering expertise. We hire and manage talent worldwide, provide dedicated teams, handle any computer-based outsourcing work, and integrate seamlessly with client operations. Based in Nepal with global reach, we deliver honest, fast collaboration and adaptation."
                }
              },
              {
                "@type": "Question",
                "name": "What types of businesses can outsource work to Bichitras?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Any business looking to outsource can work with Bichitras - from startups to large corporations, hospitals, factories, manufacturing companies, creative agencies, tech companies, e-commerce businesses, and service providers. We handle software development, design, 3D modeling, animation, digital services, and any computer-based outsourcing requirements."
                }
              },
              {
                "@type": "Question",
                "name": "Does Bichitras handle manufacturing and creative outsourcing?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, Bichitras provides comprehensive outsourcing services for manufacturing businesses needing digital solutions, 3D product modeling, visualization, and technical documentation. We also offer creative outsourcing including animation, brand development, marketing materials, and visual content creation for any industry."
                }
              },
              {
                "@type": "Question",
                "name": "How does Bichitras compare to other outsourcing providers?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras is a global IT service provider that stands out by thinking like engineers, not just service providers. We don't work in silos - we integrate with your team, think strategically, and deliver solutions that actually work. Based in Nepal with worldwide reach, we offer cost-effective outsourcing with engineering logic applied to creative and technical work."
                }
              },
              {
                "@type": "Question",
                "name": "What makes Bichitras a reliable outsourcing partner for global businesses?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Bichitras is a trusted global IT service provider with proven expertise in managing outsourced projects worldwide. We provide dedicated talent management, seamless communication across time zones, quality assurance, and complete project oversight. Our engineering approach ensures reliable delivery of software development, 3D modeling, animation, and any outsourcing requirements."
                }
              }
            ]
          }`}
        </script>
      </Helmet>

      <h2 className="agency">Agency</h2>
      <h2 className="agency-First">Agency</h2>

      <p className="about-agency">
        We're engineers working across software, <br />
        animation, brand and marketing.  <br />
        We're not pretending to be 100 people, <br />
        we just move like it.  <br />
        We collaborate fast. We adapt. We deliver honestly <br />
        <br />
        We don’t work in silos. We think like a product team. <br />
        We're based in Nepal, connected globally, <br />
        and driven by what’s next. <br />
        <br />
        BICHITRAS
      </p>

      <div className="agen">
        <video loop muted autoPlay className="agency-vid" aria-label="Video showcasing our agency work and team culture">
          <source src={Z} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="texxt-area">
        <a href="#contact" className="Button-pos" aria-label="View open job positions">See open positions</a>
        <p className="about-text">
          We analyze and question the existing, think differently and act decisively. <br />
          With a focus on strategy and creativity, we find solutions that work. <br />
          This leads not only to outstanding results, but to great partnerships. <br />
          <br />
          We don't just do development, we shape it. <br />
          Only when we truly understand the problem can we create something meaningful. <br />
          Work that ultimately leads to the goal. <br />
          <br />
          BICHITRAS
        </p>
      </div>
    </section>
  );
};

export default Four;
